import { State } from 'xstate';
import { createCustomFieldsMachine } from './customFields';

type CustomFieldsMachine = ReturnType<typeof createCustomFieldsMachine>;
type CustomFieldsState = State<CustomFieldsMachine['context']>;

export const getSubscriptionCustomFields = (
  machineState: CustomFieldsState
) => {
  return machineState.context.customFields;
};

export const getSubscriptionCustomFieldsState = (
  machineState: CustomFieldsState
) => ({
  isIdle: machineState.matches('idle'),
  isFetchLoading: machineState.matches('loading'),
  isFetchError: machineState.matches('error'),
  isReady: machineState.matches('ready'),
  isEdit: machineState.matches('customFieldsEdit'),
  isSaving: machineState.matches('customFieldsEdit.saving'),
  isSaveError: machineState.matches('customFieldsEdit.error'),
});

export const customFieldsSelectors = {
  getSubscriptionCustomFields,
  getSubscriptionCustomFieldsState,
};
